<!--线索设置-->
<template>
  <div class="app-container">
    <el-card class="operate-container" shadow="never">
      <div class="filter-container2" style="margin-top: 60px;">
        <el-form  ref="baseRef"  :model="clueSetting" :rules="rules" label-width="200px">
          <el-form-item  label="默认下次跟进间隔天数:" >
            <el-input-number v-model="clueSetting.defaultNextFollowClueDay"></el-input-number>
          </el-form-item>
          <el-form-item  label="默认下次重新跟进间隔天数:" >
            <el-input-number v-model="clueSetting.defaultNextReFollowClueDay"></el-input-number>
          </el-form-item>
          <el-button type="primary" size="medium" class="operator-btn" style="margin-top: 200px; width: 120px;" @click="onSaveClueFollowSetting">保存</el-button>
        </el-form>
      </div>
    </el-card>
  </div>




</template>

<style scoped>

  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 500px;
  }



</style>

<script>
  import commonUtils from "../../../utils/commonUtils";
  import globaldata from "../../../utils/globaldata";

  import timeUtils from "../../../utils/timeUtils";
  import messageUtils from "../../../utils/messageUtils";
  import * as enumsUtil from "../../../utils/enumsUtil";
  import {getClueFollowSetting, setClueFollowSetting} from "../../../api/StoreSetting";

  export default {
    components: {},
    data() {
      return {

        clueSetting:{
          defaultNextFollowClueDay:0,
          defaultNextReFollowClueDay:0,
        }


      }
    },

    created(){
     this.initData();

    },
    mounted() {

    },
    methods: {

      initData(){
        this.onGetClueFollowSetting();
      },

      onGetClueFollowSetting(){
        let param = {
          id:globaldata.getAdminStore().storeFrontId
        }
        getClueFollowSetting(param).then(response =>
        {
          let data  = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.clueSetting.defaultNextFollowClueDay = data.defaultNextFollowClueDay;
          this.clueSetting.defaultNextReFollowClueDay = data.defaultNextReFollowClueDay;
        })

      },
      onSaveClueFollowSetting(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          defaultNextFollowClueDay:this.clueSetting.defaultNextFollowClueDay,
          defaultNextReFollowClueDay:this.clueSetting.defaultNextReFollowClueDay,
        }
        setClueFollowSetting(param).then(response =>
        {
          let data  = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message);
          }else {
            messageUtils.errorMsg(this,response.message);
          }

        })
      }









    }
  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/clue-setting/index.vue